import {Button, makeStyles, useMediaQuery, useTheme} from "@material-ui/core";
import {useEffect, useState} from "react";
import UtilService from "../../../../../helper/service";
import {useHistory, useLocation} from "react-router";
import Module4Slide2Header from "./side2Atoms/header";
import Module4Slide2SubHeader from "./side2Atoms/subHeader";
import Module4Slide2GraphArea from "./side2Atoms/graphArea";
import Module4Slide2FilterPanel from "./side2Atoms/filterPanel";
import useWindowSize from '../../../../../helper/hooks/useWindowSize';
import {useDispatch, useSelector} from "react-redux";
import DraggableVideoSection from "./side2Atoms/draggableVideoSection";
import {
  moveNextPage,
  updateCreatorOnboarding,
  updateOnBoardingSettings
} from "../../../../../store/actions/creator/creatorOnBoarding";
import {ArrowLoading} from "../../../../atoms/commonLoadings";
import StaticVideoSection from "./side2Atoms/staticVideoSection";

const useStyles = makeStyles(() => ({
  root: {
    width: `calc(100% + 40px)`,
    height: '100%',
    marginLeft: -20,
    marginRight: -20,
    background: '#f0f0f0',
  },
  fullWidth: {
    flex: 1,
    width: '100%',
    display: 'flex',
    marginTop: 164,
  },
  cSection: {
    flex: 1,
    width: '100%',
    display: 'flex',
    marginTop: 30,
  },
  gSection: {
    flex: 1,
    flexDirection: 'column',
    display: 'flex',
    position: 'relative',
    alignItems: 'center',
    overflowX: 'hidden',
  },
  headerPanelMobile: {
    minHeight: 48,
    paddingTop: 3,
    width: '100%',
    backgroundColor: '#fff',
    borderBottom: '1px solid #D9D9D9',
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
    zIndex: 10,
  },
  dialog: {
    padding: '40px 50px',
    '@media (max-width: 1500px)': {
      padding: '25px 32px',
    },
    '@media (max-height: 800px)': {
      padding: '10px 20px',
    },
  },

  dialog4: {
    padding: '18px 50px',
    '@media (max-width: 1500px)': {
      padding: '15px 22px',
    },
  },
  title: {
    fontSize: 34,
    fontFamily: 'roboto-bold',
    textAlign: 'center',
    '@media (max-width: 1500px)': {
      fontSize: 26,
    },
    '@media (max-height: 800px)': {
      fontSize: 24,
    },
  },
  description: {
    marginTop: 30,
    fontSize: 24,
    fontFamily: 'roboto-light',
    lineHeight: 1.25,
    textAlign: 'center',
    '@media (max-width: 1500px)': {
      fontSize: 20,
    },
    '@media (max-height: 800px)': {
      fontSize: 18,
    },
  },
  close: {
    position: 'absolute',
    right: 20,
    top: 20,
    cursor: 'pointer'
  },
  paper1: {
    position: 'absolute',
    top: 60,
    padding: 20,
    boxShadow: '0px 5px 9px -1px rgba(0,0,0,0.25)',
    background: '#fff',
    zIndex: 1500,
    borderRadius: '24px!important',
  },
  arrow1: {
    position: 'absolute',
    top: 200,
    zIndex: 9900,
    transform: 'rotate(180deg)',
  },
  paper2: {
    position: 'absolute',
    boxShadow: '0px 5px 9px -1px rgba(0,0,0,0.25)',
    background: '#fff',
    zIndex: 1500,
    left: 270,
    top: 150,
    borderRadius: '24px!important',
    '@media (max-height: 800px)': {
      top: 200,
    },
  },
  arrow2: {
    position: 'absolute',
    left: 210,
    top: 320,
    zIndex: 9900
  },
  paper3: {
    position: 'absolute',
    padding: 10,
    boxShadow: '0px 5px 9px -1px rgba(0,0,0,0.25)',
    background: '#fff',
    zIndex: 1500,
    left: 500,
    top: 480,
    borderRadius: '24px!important',
    '@media (max-width: 1300px)': {
      left: 200,
    },
    '@media (max-height: 800px)': {
      padding: 2,
      top: 460,
    },
  },
  paper4: {
    position: 'absolute',
    margin: 0,
    boxShadow: '0px 5px 9px -1px rgba(0,0,0,0.25)',
    background: '#fff',
    zIndex: 1500,
    left: 450,
    top: 380,
    borderRadius: '24px!important',
    '@media (max-width: 1300px)': {
      left: 200,
    },
  },
  arrow3: {
    position: 'absolute',
    top: 440,
    zIndex: 9900,
    transform: 'rotate(90deg)',
  },
  row: {
    marginTop: 32,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '& img': {
      width: '50%',
      '@media (max-width: 1600px)': {
        left: 600,
        width: '40%'
      },
    }
  },
  btn: {
    width: 180,
    marginTop: 22,
    fontFamily: 'roboto-regular',
    fontSize: 16,
    marginRight: 0,
    padding: '6px 27px',
    background: '#017AEF',
    margin: "10px",
    color: '#fff',
    textTransform: 'none',
    '&:hover': {
      background: '#0f9fef',
      color: '#fff',
    },
  },
}));

const delay_seconds = 8000;

const Module4Slide2 = () => {
  const { width, height } = useWindowSize();
  const classes = useStyles(width);
  const location = useLocation();
  const history = useHistory();
  const theme = useTheme();
  const dispatch = useDispatch();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const { userPreferences, module4Settings } = useSelector((state: any) => state.creatorOnBoarding);
  const { videoplayed, tagtoggled, compared, activepage, module4Data } = userPreferences;
  const { analyze, session } = module4Data.value;
  const { filter, graphZoom } = module4Settings;
  const stimulus = analyze?.stimulus;
  const [open, setOpen] = useState(0);
  const apolloClient = useSelector((state: any) => state.apolloClient);
  const loginUserData = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data") || "{}") : "";

  const bestMomentPoint = session.best_moments[0]?.epoch_start || 160;
  // const bestMomentPoint = 10;

  useEffect(() => {
    UtilService.addHashTag(history, location.pathname, 'm4s2');
  }, []);

  useEffect(() => {
    if (session) {
      const { session_trim_from, session_trim_to, scheduled_end_at, started_at, ended_at } = session;
      const analysed_end = Math.floor(ended_at ? ended_at : scheduled_end_at);
      const analyseStart = session_trim_from ? Number(session_trim_from) : Number(started_at)
      const analyseEnd = session_trim_to ? Number(session_trim_to) : analysed_end
      dispatch(updateOnBoardingSettings("analyseStart", analyseStart))
      dispatch(updateOnBoardingSettings("analyseEnd", analyseEnd))
    }
  }, [session]);

  useEffect(() => {
    if (!videoplayed.value) setOpen(1);
    if (videoplayed.value && !tagtoggled.value) setTimeout(() => open < 2 && setOpen(2), delay_seconds);
    if (videoplayed.value && tagtoggled.value && !compared.value) setTimeout(() => open < 3 && setOpen(3), delay_seconds);
    if (videoplayed.value && tagtoggled.value && compared.value) setTimeout(() => open < 4 && setOpen(4), delay_seconds * 2);
  }, [videoplayed, tagtoggled, compared]);

  useEffect(() => {
    if(width < 769) {
      setTimeout(() => dispatch(moveNextPage(16)), delay_seconds * 2);
    }
  }, [width]);

  const onVideoPlayed = () => {
    open < 1.5 && setOpen(1.5);
    if (!videoplayed.value) {
      const request = {
        user_id: loginUserData.user_id,
        preference_id: userPreferences.videoplayed.id,
        preference_name: 'VIDEOPLAYED',
        preference_information: 'true',
      };
      dispatch(updateCreatorOnboarding(apolloClient.client, request));
    }
  };

  const onTagToggled = () => {
    if (open < 2) { return false }

    open < 2.5 && setOpen(2.5);
    if (!tagtoggled.value) {
      const request = {
        user_id: loginUserData.user_id,
        preference_id: userPreferences.tagtoggled.id,
        preference_name: 'TAGTOGGLED',
        preference_information: 'true',
      };
      dispatch(updateCreatorOnboarding(apolloClient.client, request));
    }
  };

  const onPillClicked = () => {
    if (open < 3) { return false }
    open < 3.5 && setOpen(3.5);
    const request = {
      user_id: loginUserData.user_id,
      preference_id: userPreferences.compared.id,
      preference_name: 'COMPARED',
      preference_information: 'true',
    };
    dispatch(updateCreatorOnboarding(apolloClient.client, request));
  }

  const onDoneClicked = () => {
    setOpen(0);
    onNextPage();
  }

  const onNextPage = () => {
    if (videoplayed.value && tagtoggled.value && compared.value) {
      if (Number(activepage.value) < 16) {
        const reqActivePage = {
          user_id: loginUserData.user_id,
          preference_id: userPreferences.activepage.id,
          preference_name: 'ACTIVEPAGE',
          preference_information: '16',
        };
        dispatch(updateCreatorOnboarding(apolloClient.client, reqActivePage));
      }
      dispatch(moveNextPage(16))
    }
  }

  return (
    <div className={classes.root}>
      <Module4Slide2Header />
      <Module4Slide2SubHeader />

      {width > 319 ? <div className={classes.fullWidth} style={{ background: '#f0f0f0' }}>
        {filter && !isMobile && <Module4Slide2FilterPanel onHandleToggle={onTagToggled} />}
        <div className={classes.cSection} style={{ marginTop: isMobile ? (width < 600 ? 50 : 50) : 50 }}>
          <div className={classes.gSection}>
            {stimulus && !isMobile && <DraggableVideoSection onVideoPlay={onVideoPlayed} />}
            {stimulus && isMobile && <StaticVideoSection />}
            <Module4Slide2GraphArea onPillClicked={onPillClicked} />
          </div>
        </div>
      </div> : <> Mobile Not Available</>}

      {
        !isMobile && open === 1 &&
        <div className={classes.paper1} style={{left: width/2 - (width > 1500 ? 630 : 530)}}>
          <div className={classes.dialog}>
            <div className={classes.title} >Welcome to Your Analyze Tab!</div>
            <div className={classes.description}>
              Play the video to see second-by-second how <br /> your audience responded to the video.
            </div>
            <div className={classes.row}>
              <img src="/assets/images/module41.svg" alt={'img'} />
            </div>
          </div>
        </div>}

      {
        !isMobile && open === 1 &&
        <div className={classes.arrow1} style={{left: width/2 - 100}}>
          <ArrowLoading />
        </div>}

      {
        !isMobile && open === 2 &&
        <div className={classes.paper2}>
          <div className={classes.dialog}>
            <div className={classes.title}>Now toggle on tags</div>
            <div className={classes.description}>
              This lets you see the difference in how different groups<br /> of participants responded to the video... in this case<br /> men vs. women.
            </div>
            <div className={classes.row}>
              <img src="/assets/images/module42.svg" alt={'img'} />
            </div>
          </div>
        </div>}

      {
        !isMobile && open === 2 &&
        <div className={classes.arrow2}>
          <ArrowLoading />
        </div>}

      {
        !isMobile && open === 3 &&
        <div className={classes.paper3}>
          <div className={classes.dialog}>
            <div className={classes.row} style={{ marginTop: 0 }}>
              <div>
                <div className={classes.title} style={{ lineHeight: 1.6, textAlign: 'left' }}>See these green and red dots?</div>
                <div className={classes.description} style={{ textAlign: 'left', marginTop: 10 }}>
                  Green dots are scientifically likely to be tagged as memories.<br />
                  Red dots are moments the audience tuned out. Click them to see <br />exactly what was happening in the video at that exact moment!
                </div>
              </div>
              <img src="/assets/images/woman-dots.svg" alt={'img'} style={{ width: height > 800 ? 130 : 90 }} />
            </div>
          </div>
        </div>}

      {
        !isMobile && open === 3 &&
        <div
          className={classes.arrow3}
          style={{ left: width > 0 ? (width > 1200 ? 385 : 295) + bestMomentPoint * 15 / Math.pow(graphZoom, 2) : 0 }}
        >
          <ArrowLoading />
        </div>}

      {
        !isMobile && open === 4 &&
        <div className={classes.paper4}>
          <div className={classes.dialog4}>
            <div className={classes.row} style={{ marginTop: 0 }}>
              <img src="/assets/images/module44.png" alt={'img'} style={{ width: height > 800 ? 280 : 220 }} />
              <div>
                <div className={classes.title} style={{ lineHeight: 1.6, textAlign: 'left' }}>Awesome! Almost done with Module 4!</div>
                <div className={classes.description} style={{ textAlign: 'right', marginTop: 7, lineHeight: 1.5 }}>
                  Don’t worry; if you want to further investigate these results,<br />
                  this experience, along with others, will be in your<br />
                  Experience Dashboard for you to explore anytime.<br />
                  Click below to complete your onboarding!<br/>
                  <Button className={classes.btn} color='primary' size='large' onClick={onDoneClicked}>
                  Done
                </Button>
                </div>
               
              </div>
            </div>
          </div>
        </div>}

    </div>
  )
};

export default Module4Slide2;